import { render, staticRenderFns } from "./EleFormTag.vue?vue&type=template&id=54250929&"
import script from "./EleFormTag.vue?vue&type=script&lang=js&"
export * from "./EleFormTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports